<template>
<div v-if="thread">
  <template v-if="error">{{error}}</template>
  <template v-else>
    <vue-headful :title="htmlDecode(thread.title) + ' — ' + site_title" />
    <Header :breadcrumbs="bread" />

    <!-- pages widget -->
    <ThreadPages :totalItems="thread.numPosts" :prependIntoLink="'index.php?showtopic='+this.$route.query.showtopic" :itemsPerPage="20" />

    <!-- thread main div -->
    <div class="forums">

      <!-- thread title and subtitle -->
      <div class="forum__section_title">
        <img src="../assets/nav_m.gif" /> {{htmlDecode(thread.title)}}<template v-if="thread.description.length > 0">,</template>
        {{htmlDecode(thread.description)}}
        <span style="float: right;"><a>Каскадный</a> · [ <a>Стандартный</a> ] · <a>Линейный</a></span>
      </div>

      <!-- poll here (optional) -->
      <template v-if="thread.poll && thread.poll.choices && thread.poll.choices.length > 0">
        <div class="forum__thread_subtitle thread_poll_title">
          {{htmlDecode(thread.poll.poll_question)}}
        </div>
        <div class="thread_poll_subtitle"></div>
        <table cellspacing="1" class="thread__poll_table">
          <tbody>
            <tr v-for="(pollChoice, index) in thread.poll.choices">
              <td width="30%" :class="{thread__poll_first_entry: index === 0}" class="thread_poll_first_column">{{htmlDecode(pollChoice.choice)}}</td>
              <td width="3%" :class="{thread__poll_first_entry: index === 0}" class="thread__poll_middle">[ <b>{{htmlDecode(pollChoice.votes)}}</b> ]</td>
              <td width="30%" :class="{thread__poll_first_entry: index === 0}">
                <img src="../assets/bar_left.gif" />
                <img src="../assets/bar.gif" :width="pollChoice.votes / thread.poll.votes * 400" height="11" />
                <img src="../assets/bar_right.gif" />
                [{{parseFloat(pollChoice.votes / thread.poll.votes * 100).toFixed(2)}}%]
              </td>
            </tr>
            <tr>
              <td colspan="3" class="thread__poll_middle"><b>Всего голосов: {{thread.poll.votes}}</b></td>
            </tr>
            <tr>
              <td colspan="3" class="thread__poll_bottom_decorator"></td>
            </tr>
          </tbody>
        </table>
      </template>
      <!-- end of poll -->

      <div class="forum__thread_subtitle">
        <a>Подписка на тему</a> | <a>Сообщить другу</a> | <a>Версия для печати</a> | <a>Кто просматривал тему</a>
      </div>
      <!-- end of thread title -->

      <!-- foreach post -->
      <table v-for="(post, index) in thread.posts" cellspacing="1">
        <tbody>
          <!-- row: poster name, date, post number -->
          <tr class="forum__thread_row_top">
            <td width="1%" align="center">
              <template v-if="post.author_id > 0">
                <a><b>{{htmlDecode(post.name) + ' '}}</b></a>
              </template>
              <template v-else>
                {{htmlDecode(post.name) + ' '}}
              </template>
              <!-- TODO: v-if offline/online -->
              <img src="../assets/p_offline.gif" :title="'User is offline'">
            </td>
            <td width="99%" valign="top">
              <!-- POSTED DATE DIV -->
              <div class="thread__post_date_flex">
                <div>
                  <img src="../assets/to_post_off.gif" style="margin-top: 2px;"> {{post.post_date | formatDate}}
                </div>
                <div class="last_elem">
                  Отправлено <a :id="post.pid" title="Ссылка этого сообщения" :href="'#' + post.pid">#{{index+1+skipThreads}}</a>
                </div>
              </div>
            </td>
          </tr>

          <!-- row: avatar, post, etc -->
          <tr class="forum__thread_row_mid">
            <!-- AVATAR, etc... -->
            <td class="thread__poster_info_box" valign="top" align="center">

              <!-- AVATAR -->
              <template v-if="post.avatar !== null && post.avatar.length > 0 && post.avatar !== 'noavatar'">
                <img class="avatar" :src="fixAvatarPath(post.avatar)" />
              </template>
              <br>
              <br>
              <!-- title -->
              <template v-if="post.title !== null && post.title.length> 0">{{htmlDecode(post.title)}}</template> <!-- custom title -->
              <template v-else>{{getTitleFromPosts(post.posts)}}</template> <!-- normal title -->
              <br>
              <!-- PIPS -->
              <div>
                <img v-for="n in getPipsFromPosts(post.posts)" src="../assets/pip.gif" :alt="n | consumeN">
              </div>
              Сообщений: {{post.posts | formatInt}}<br>
              Золото: <b><span style="color: gold;">{{post.author_id === 379 ? '&infin;' : post.gold | formatInt}}</span></b><br> <!-- ranma special case: infinite gold -->
              <template v-if="post.awards > 0">
                Награды:
                <a class="forum__thread_awards">
                  {{post.awards}}
                </a>
              </template>
              <br>
              <br>
              <div style="width: 160px; height: 1px;"></div>
              <br>
            </td>
            <!-- POST -->
            <td class="thread__posttext" width="100%" valign="top">
              <!-- THE POST -->
              <div v-html="fixVariousTags(fixNewsTags(fixRpgplanetLinks(fixSmileysPath(post.post)), post))"></div>

              <!-- edited by... Сообщение отредактировал virus_found - 29 September 2004, 00:42  -->
              <div v-if="post.append_edit" class="thread__edit_by">
                <br>
                Сообщение отредактировал <b>{{htmlDecode(post.edit_name)}}</b> - {{post.edit_time | formatDate}}
              </div>

              <!-- Signature -->
              <div class="thread__signature" v-if="post.use_sig && post.signature && post.signature.length > 0">
                <br><br>
                --------------------
                <br>
                <div v-html="fixVariousTags(fixRpgplanetLinks(post.signature))"></div>
              </div>
            </td>
          </tr>

          <!-- row: buttons like PM, quote, reply, etc... -->
          <tr class="forum__thread_row_bottom">
            <td></td>
            <td>
              <!--  PM / EMAIL / WWW / MSGR  -->
              <div style="float:left;">
                <img src="../assets/p_up.gif" @click="goToTop()" style="cursor: pointer;" />
                <a><img src="../assets/p_card.gif" /></a>
                <a><img src="../assets/p_pm.gif" /></a>
                <template v-if="post.website && post.website.length > 0 && post.website !== 'http://'">
                  <a :href="post.website"><img src="../assets/p_www.gif" /></a>
                </template>
                <img v-if="post.icq_number" src="../assets/p_icq.gif" />
              </div>
              <!-- QUOTE / REPLY -->
              <div align="right">
                <a title="Добавить к многочисленным цитатам">
                  <img src="../assets/p_mq_add.gif" />
                </a>
                <a title="Ответить прямо в этом сообщении">
                  <img src="../assets/p_quote.gif" />
                </a>
              </div>
            </td>
          </tr>

          <!-- row: decorative separator -->
          <tr>
            <td class="thread__end_decorator" colspan="2"></td>
          </tr>

        </tbody>
      </table>

      <!-- end of foreach post -->


    </div> <!-- end of <div class="forums"> -->

    <!-- pages again -->
    <ThreadPages :totalItems="thread.numPosts" :prependIntoLink="'index.php?showtopic='+this.$route.query.showtopic" :itemsPerPage="20" />
  </template> <!-- v-else (if no error)-->
  <FooterPermanent v-if="this.footerReady" :loadTime="this.loadTime" :totalRequests="this.queries" />
</div>
</template>

<script>
import Header from './Header'
import ThreadPages from './ThreadPages'
import FooterPermanent from './FooterPermanent'
import {
  globalFormatDate
} from '../../public/utils.js';

export default {
  components: {
    Header,
    ThreadPages,
    FooterPermanent
  },
  data: function() {
    return {
      thread: null,
      bread: null,
      skipThreads: 0,
      error: null,
      footerReady: false
    }
  },
  async created() {
    console.time("PageLoadTime");
    let response = null;
    let dateEarly = new Date();
    let pagenumber = 0;
    if (this.$route.query.st) {
      pagenumber = Number(this.$route.query.st);
      if (!pagenumber)
        pagenumber = 0;
    }

    let threadNumber = this.$route.query.showtopic.replace(/\D/g, ''); // strip non-numeric characters
    threadNumber = Number(threadNumber);
    if (!threadNumber)
      threadNumber = 0;

    response = await fetch(this.getNodePath() + 'thread/' + threadNumber + '/page/' + pagenumber);
    let dateLater = new Date();
    let data = await response.json();
    this.thread = data;
    if (data.error) {
      this.error = data.error;
    } else {
      this.queries = data.queries;
      this.bread = data.bread;
      this.skipThreads = pagenumber;
      this.loadTime = this.spanSeconds(dateEarly, dateLater);
      this.footerReady = true;
    }
    //console.log(data);
    console.timeEnd("PageLoadTime");

    // if we have a link ending with e.g. #1234 (post number)
    if (location.hash) {
      this.$nextTick(() => {
        const postId = location.hash.substring(1);
        const element = document.getElementById(postId);
        element.scrollIntoView();
      });
    }
  },
  methods: {
    getTitleFromPosts(posts) {
      if (posts >= 15000)
        return "Titan";
      else if (posts >= 7500) {
        return "Expanded Member III";
      } else if (posts >= 3000) {
        return "Expanded Member II";
      } else if (posts >= 1500) {
        return "Expanded Member";
      } else if (posts >= 750) {
        return "Extended Member";
      } else if (posts >= 300) {
        return "Advanced Member";
      } else if (posts >= 150) {
        return "Member";
      } else if (posts >= 50) {
        return "Newbie"
      }
      return "Nobody";
    },
    getPipsFromPosts(posts) {
      if (posts >= 15000)
        return 8;
      else if (posts >= 7500) {
        return 7;
      } else if (posts >= 3000) {
        return 6;
      } else if (posts >= 1500) {
        return 5;
      } else if (posts >= 750) {
        return 4;
      } else if (posts >= 300) {
        return 3;
      } else if (posts >= 150) {
        return 2;
      } else if (posts >= 50) {
        return 1
      }
      return 0;
    },
    fixSmileysPath(postText) {
      return postText.replace(/<#EMO_DIR#>\//g, "");
    },
    fixNewsTags(newsPost, post) { // only affects OP posts
      if (!post.new_topic)
        return newsPost;
      // strip [preview] and [/preview] tags
      return newsPost.replace(/\[preview\](.+?)\[\/preview\]/gi, "$1");
    },
    fixRpgplanetLinks(html) {
      // oldforums.rpgplanet.ru to /oldforums/, examples: http://localhost:8080/index.php?showtopic=221#2995
      // steelworld.rpgplanet.ru/forums/ to local url
      // etc,.. many such cases.
      // eg. http://localhost:8080/index.php?showtopic=3603 , http://localhost:8080/index.php?showtopic=192&st=268
      return html.replace(/<a href=("|')http:\/\/((www|forums)\.){0,2}((.{0,15}?)\.){0,1}?(rpgplanet|realms)\.ru(\/forums)?/gu, function(a, b, c, d, e, f) {
          let result = '';
          if (f) {
            result = `<a href=${b}/${f}`;
          } else {
            result = `<a href=${b}`;
          }
          return result;
        })
        // img src="http://www.rpgplanet.ru/forums" (and without forums) to local website url
        .replace(/<img src="http:\/\/www\.rpgplanet\.ru(\/forums){0,1}/g, function(a, b) {
          return a.replace("http://www.rpgplanet.ru/forums", "").replace("http://www.rpgplanet.ru", "");
        });
    },
    goToTop() {
      scroll(0, 0);
    },
    fixVariousTags(html) {
      // [mergetime=1232312] turns it into Добавлено: дата
      return html.replace(/\[mergetime=(\d+)\]/g, function(a, b) {
          return '<b>Добавлено: ' + globalFormatDate(b) + '</b>';
        })
        // changes [hide]text[/hide] to <i>text</i> - hide tag was used to hide info from unregistered users only
        .replace(/\[hide\](.*?)\[\/hide\]/gi, "<i>$1</i>")
        // change [topic=123]text[/topic] to <a href="index.php?showtopic=123">text</a>
        .replace(/\[topic=([0-9]+)\](.+?)\[\/topic\]/gi, "<a href=\"/index.php?showtopic=$1\">$2</a>")
        // same with [user]
        .replace(/\[user=([0-9]+)\](.+?)\[\/user\]/gi, "<a href=\"/index.php?showuser=$1\">$2</a>")
        // same with [forum]
        .replace(/\[forum=([0-9]+)\](.+?)\[\/forum\]/gi, "<a href=\"/index.php?showforum=$1\">$2</a>")
        // same with [post]
        .replace(/\[post=([0-9]+)\](.+?)\[\/post\]/gi, "<a href=\"/index.php?view=findpost&p=$1\">$2</a>")
        // [hl] tag gives text a different color
        .replace(/\[hl\](.+?)\[\/hl\]/gi, "<span class=\"thread__hl\">$1</span>");
    }
  },
  filters: {
    consumeN: function(number) {
      return "*";
    }
  }
}
</script>

<style lang="scss">
@import "./Thread.scss";
</style>
